<template>
  <v-menu :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-if="!isRascunho(item)"
        :disabled="isEditDisabledCancelada(item)"
        @click="goToEditCompra(item)"
      >
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Editar compra
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isRascunho(item)" @click="goToEditCompraRascunho(item)">
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Editar rascunho
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isRascunho(item)" @click="onClickDeleteRascunho(item)">
        <v-list-item-icon>
          <v-icon>mdi-delete</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Remover rascunho
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="!isRascunho(item)"
        :disabled="isMoedaEstrangeiraFn(item.moeda)"
        @click="onClickCopy(item)"
      >
        <v-list-item-icon>
          <v-icon>mdi-content-copy</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Copiar compra
        </v-list-item-content>
      </v-list-item>
      <px-avaliacao-dialog
        v-if="!item.avaliacao && !isRascunho(item)"
        :compra-id="item.id"
        :disabled="isOrigemCadastro(item) || !isFinalizada(item)"
        :name="item.fornecedor.pessoa.nome"
        @update="emitUpdate"
      >
        <template v-slot:activator="{ on }">
          <v-list-item v-on="on" :disabled="isOrigemCadastro(item) || !isFinalizada(item)">
            <v-list-item-icon>
              <v-icon>mdi-star-plus-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              Avaliar compra
            </v-list-item-content>
          </v-list-item>
        </template>
      </px-avaliacao-dialog>
      <px-show-avaliacao-menu v-if="item.avaliacao" :avaliacao="item.avaliacao.avaliacao">
        <template v-slot:activator="{ on }">
          <v-list-item v-on="on">
            <v-list-item-icon>
              <v-icon>mdi-star</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              Ver avaliação
            </v-list-item-content>
          </v-list-item>
        </template>
      </px-show-avaliacao-menu>
    </v-list>
    <px-confirm-dialog ref="confirm"/>
  </v-menu>
</template>

<script>
import { SituacaoCompra } from 'px-business-components';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [moedaMixin],
  props: {
    item: Object,
  },
  data() {
    return {
      loadingLink: false,
    };
  },
  computed: {
    isOrigemCadastro() {
      return item => item.processoAprovacao !== true;
    },
    isFinalizada() {
      return item => SituacaoCompra.keys.APROVADA.key === item.situacao;
    },
    isEditDisabledCancelada() {
      return item => [
        SituacaoCompra.keys.CANCELADA.key,
        SituacaoCompra.keys.RECUSADA.key,
        SituacaoCompra.keys.RASCUNHO.key,
        SituacaoCompra.keys.AGUARDANDO_APROVACAO_INTERNA.key,
      ].includes(item.situacao);
    },
    isRascunho() {
      return item => SituacaoCompra.keys.RASCUNHO.key === item.situacao;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    removeRascunho(item) {
      this.$emit('remove-rascunho', item);
    },
    goToEditCompra(item) {
      if (item.situacao === SituacaoCompra.keys.ELABORACAO.key) {
        this.$refs.confirm.open('Certifique-se de que a integração esteja finalizada antes de avançar.',
          'Antes de editar, certifique-se de que a compra em elaboração tenha finalizado o processo de integração. A edição antecipada pode causar a duplicação da compra no seu ERP.',
          { width: 450 })
          .then((confirm) => {
            if (confirm) {
              this.goToEditCompraConfirm(item);
            }
          });
      } else {
        this.goToEditCompraConfirm(item);
      }
    },
    goToEditCompraConfirm(item) {
      this.$router.push({
        name: 'main.compras.edicao',
        params: {
          id: item.id,
        },
        query: {
          isRascunho: false,
          isCopy: false,
        },
      });
    },
    goToEditCompraRascunho(item) {
      this.$router.push({
        name: 'main.compras.edicao',
        params: {
          id: item.id,
        },
        query: {
          isRascunho: true,
          isCopy: false,
        },
      });
    },
    onClickDeleteRascunho(item) {
      this.$refs.confirm
        .open(
          'Você deseja remover este rascunho de compra?',
          'O rascunho da compra será removido e esta operação não pode ser desfeita.',
          { width: 450 },
        )
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.removeRascunho(item);
        });
    },
    onClickCopy(item) {
      this.$router.push({
        name: 'main.compras.cadastro',
        params: {
          id: item.id,
        },
        query: {
          isRascunho: false,
          isCopy: true,
        },
      });
    },
  },
};
</script>
